export function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      // 현재 경로에서 /roulette/ prefix가 있는지 확인
      const basePath = window.location.pathname.startsWith('/roulette/') ? '/roulette' : '';
      const swUrl = `${window.location.origin}${basePath}/service-worker.js`;
      navigator.serviceWorker
        .register(swUrl)
        .then((reg) => console.log('service worker registered', reg.scope))
        .catch((err) => console.error('service worker registration failed', err));
    });
  }
}
